const Module = {
    AUDIT: 'audit',
    USER: 'user',
    ROLE: 'role',
    USER_ADDRESS: 'userAddress',
    SETTING: 'setting',
    SYSTEM_SETTING: 'systemSetting',
    PUSH_NOTIFICATION: 'pushNotification',
    COMPLAINT: 'complaint',
    RECOVERY_REQUEST: 'recoveryRequest',
    EMERGENCY_CONTACT: 'emergencyContact',
    VEHICLE_TYPE: 'vehicleType',
    DRIVER_VEHICLE: 'driverVehicle',
    FARE: 'fare',
    ORDER: 'order',
    BANNER: 'banner',
    VIDEO: 'video',
    DRIVER_APPLICATION: 'driverApplication',
    QUIZ: 'quiz',
    OPTION: 'option',
    ATTEMPT: 'attempt',
    DASHBOARD: 'dashboard',
    WITHDRAWAL: 'withdrawal',
    ADMIN: 'admin',
    DRIVER: 'driver',
    TRANSACTION: 'transaction',
    DRIVER_TIER: 'driverTier',
}

export default Module;